(() => {
  function openDetails(hash) {
    if (!hash?.startsWith('#WkProductDetails-')) return;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
    const details = document.getElementById(id);
    if (details instanceof HTMLDetailsElement) details.open = true;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href^="#WkProductDetails-"]');
    if (link) openDetails(link.hash);
  });
  window.addEventListener('hashchange', () => openDetails(location.hash));
  openDetails(location.hash);
})();
